import { render, staticRenderFns } from "./NuevaSituacionRevista.vue?vue&type=template&id=5b5c1506&"
import script from "./NuevaSituacionRevista.vue?vue&type=script&lang=js&"
export * from "./NuevaSituacionRevista.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports